import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {CreditBenefitItemProps} from '@Components/checkout-flow/components/credit-benefit-item/credit-benefit-item.types';
import styles from './credit-benefit-item.module.scss';

export function CreditBenefitItem({benefit}: CreditBenefitItemProps): ReactElement {
  return (
    <li className={styles.item}>
      <div className={styles.iconBox}>
        <Icon icon={benefit.icon} size={IconSize.SIZE_ICON_24} className={benefit.isAi ? styles.aiIcon : styles.icon} ariaHidden />
      </div>
      <div className={styles.texts}>
        <Text val={window.i18next.t(benefit.titleKey)} size={TextSize.MD} bold className="ct-neutral-primary-on-dark" />
        <Text val={window.i18next.t(benefit.descriptionKey)} size={TextSize.SM} className="ct-neutral-secondary-on-dark" />
      </div>
    </li>
  );
}
